<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'TaskTypes',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Типы задач',
        canEdit: true,
        apiRoute: 'nsitasktype',
        cardName: 'TaskTypeCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
